import { Alert, Box, Button, Menu, MenuItem, Typography } from '@mui/material';
import React, { Component } from 'react';
import Global from "../../customlib/Global";
import Api from "../../customlib/Api";
import axios from 'axios';
import { MarkChatUnread } from '@mui/icons-material';

class TopAlert extends Component {
    state = {
        anchorEl: null,
        isMenuOpen: false,
        appNumber: Global.getAppProfile().waNumber
    }

    handleClick = (event) => {
        this.setState({ anchorEl: event.currentTarget, isMenuOpen: true });
    };

    handleClose = () => {
        this.setState({ anchorEl: null, isMenuOpen: false });
    };

    getContactInfo = (waNumber) => {
        const params = { waNumber: waNumber };
        axios
            .post(Api.getContactInfo(), params, Api.getRequestHeader())
            .then((response) => {
                const responseData = response.data;
                if (responseData.success === true) {
                    const contact = this.props.generateItemConversation(responseData.data);
                    this.props.handleConversationSelected(contact);
                }
            })
            .catch((error) => {
                this.setState({ errorMessage: error.message });
                console.error("There was an error!", error);
            });
    }

    render() {
        const count = this.props.listPesanBelumDibalas?.length || 0;

        return (
            <Box sx={{ m: "8px" }}>
                <Alert
                    severity="warning"
                    variant="standard"
                    icon={<MarkChatUnread />}
                    action={
                        <Button
                            size="small"
                            variant="contained"
                            color="warning"
                            disableElevation
                            onClick={this.handleClick}
                            sx={{ borderRadius: "8px", textTransform: "none", fontWeight: 600, whiteSpace: "nowrap", alignSelf: "center" }}
                        >
                            Cek sekarang
                        </Button>
                    }
                    sx={{
                        borderRadius: "12px",
                        alignItems: "center",
                        border: "1px solid #ffe0a3",
                        "& .MuiAlert-message": { py: "4px" },
                    }}
                >
                    <Typography sx={{ fontSize: 13.5 }}>
                        <Box component="span" sx={{ fontWeight: 700 }}>{count}</Box> pesan customer belum dibalas
                    </Typography>
                </Alert>

                <Menu
                    id="menu-pesan-belum-dibalas"
                    anchorEl={this.state.anchorEl}
                    open={this.state.isMenuOpen}
                    onClose={this.handleClose}
                    MenuListProps={{ 'aria-labelledby': 'basic-button', sx: { py: "4px" } }}
                    slotProps={{ paper: { sx: { borderRadius: "12px", maxHeight: 380 } } }}
                >
                    {this.props.listPesanBelumDibalas?.map((item, index) => (
                        <MenuItem
                            key={index}
                            disabled={this.state.appNumber !== item.to}
                            onClick={() => this.getContactInfo(item.from)}
                            sx={{ px: "8px", py: "4px" }}
                        >
                            <Box
                                sx={{
                                    width: 268,
                                    p: "8px 10px",
                                    borderRadius: "10px",
                                    border: "1px solid #ffe0a3",
                                    backgroundColor: "#fffdf7",
                                }}
                            >
                                <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 1 }}>
                                    <Typography sx={{ fontWeight: 700, fontSize: 13, textTransform: "capitalize", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                                        {item.fromName}
                                    </Typography>
                                    <Typography sx={{ fontSize: 10, fontWeight: 700, color: "#8a5a00", whiteSpace: "nowrap" }}>
                                        {item.aplikasi} {item.isCsCustomer ? "(CS)" : ""}
                                    </Typography>
                                </Box>

                                <Typography sx={{ fontSize: 11, color: "#667781", mt: "2px" }}>
                                    {Global.maskPhoneNumber(item.from)}
                                </Typography>

                                <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mt: "6px", gap: 1 }}>
                                    <span className={Global.getLabelClasses(item.label)} style={{ fontSize: "10px" }}>{item.label}</span>
                                    <Typography sx={{ fontSize: 10, color: "#98a2b3", whiteSpace: "nowrap" }}>
                                        {Global.formatDateTimeToStrDateTime24(item.lastMessageReceivedAt, true)}
                                    </Typography>
                                </Box>
                            </Box>
                        </MenuItem>
                    ))}
                </Menu>
            </Box>
        );
    }
}

export default TopAlert;
